module.exports = __webpack_public_path__ + "img/pp3.c0cafd8c.png";